<template>  
<div> <!-- root element start -->
    <div  class="row" v-if="dataComp == 0">
      <div class="col-12 mt-4">
        <scaling-squares-spinner :animation-duration="2000" :size="65" color="#0E1698" style="margin:auto"/>
      </div>
    </div>
    <div v-if="dataComp == 1" class="row">
      <div class="col-12">
        <div class="card border-0">
          <div class="card-header bg-transparent border-0 pb-0 d-flex justify-content-between align-items-center">
            <span class="h5">Organization</span>
          </div>
          <div class="card-body pb-1">
              <div class="row mb-2">
                <div class="col-12"><span class="font-weight-bold">{{ data.org.name }}</span></div>
              </div>

              <div v-if="data.org.address != null" class="row">
                <div class="col-12"><span class="">{{ data.org.address.name }}</span></div>
                <div class="col-12"><span class="">{{ data.org.address.addr1 }}</span></div>
                <div v-if="data.org.address.addr2 != null" class="col-12"><span class="">{{ data.org.address.addr2 }}</span></div>
                <div class="col-12">
                  <span class="">{{ data.org.address.city }},</span>
                  <span class=""> {{ data.org.address.state }}</span>
                  <span class=""> {{ data.org.address.zip }}</span>
                </div>

              </div>
              <div v-if="data.org.address == null" class="row">
                
              </div>

          </div>
        </div>
      </div>
    </div>

    <hr class="bg-dark my-2">
</div> <!-- root element end -->
</template>


<script>
import { ScalingSquaresSpinner } from 'epic-spinners'
import {store} from '../../stores/contact-main-store.js'


// import catMain from '../InstComponents/CategoryComponents/category-main.vue'


export default {
  store,
  data: function () {
    return { 



    }
  },
  computed: {
    data () { return this.$store.state.contactDetails },
    dataComp () { return this.$store.state.contactDetailsComp },
  },
  watch: {
    
  },
  mounted() {
    
  },
  methods: {
    changeRightView(name, prop1, prop2) { this.$store.dispatch("getRightView", { name: name, prop1: prop1, prop2: prop2 }); },
    editAddress(x) {
      var _this = this;
      _this.$emit('onSecComplete', ['launchEditAddress', x])
    },
    editOrg(x) {
      var _this = this;
      _this.$emit('onSecComplete', ['launchEditOrg', x])
    }
  },    
  components:{
    ScalingSquaresSpinner
  },
  filters: {

  }
}
</script>
